import Backdrop from '@mui/material/Backdrop';
import { Modal as MuiModal, ModalProps } from '@mui/material';
import Fade from '@mui/material/Fade';
import CloseIcon from '@/assets/icons/x-icon-grey.svg';

export interface IModalProps extends ModalProps {
    open: boolean;
    closeOnClickOutside?: boolean;
    hideCloseIcon?: boolean;
    contentClassName?: string;
    defaultContentSizes?: boolean;
    defaultPaddings?: boolean;
    dataTestId?: string;
    children: React.ReactNode;
    onClose: () => void;
}

export const Modal = ({
    children,
    open,
    closeOnClickOutside = true,
    hideCloseIcon,
    contentClassName,
    defaultContentSizes = true,
    dataTestId = 'modal',
    defaultPaddings = true,
    onClose
}: IModalProps) => {
    const handleClose = (_: object, reason: 'backdropClick' | 'escapeKeyDown') => {
        if (closeOnClickOutside || reason !== 'backdropClick') {
            onClose();
        }
    };
    return (
        <MuiModal
            data-testid={dataTestId}
            className="modal"
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            style={{
                outline: 'none'
            }}
            slotProps={{
                backdrop: {
                    timeout: 300,
                    style: { pointerEvents: 'auto' }
                }
            }}
            onClick={() => handleClose({}, 'backdropClick')}
            sx={{ zIndex: 999 }}
        >
            <Fade in={open}>
                <div className="modal-scrollbar absolute left-0 top-0 z-10 flex h-full w-full justify-center overflow-y-auto py-[2%]">
                    <div
                        className={`${contentClassName || ''} relative z-10 my-auto h-fit w-[92%] rounded-2xl bg-white shadow-modal focus:outline-none ${defaultContentSizes ? 'sm:max-w-[400px] md:max-w-[450px] lg:max-w-[528px] xl:max-w-[560px]' : ''} ${defaultPaddings ? 'lg:px-[50px px-5 py-6 lg:py-[40px]' : ''}`}
                        onClick={e => e.stopPropagation()}
                    >
                        {!hideCloseIcon && (
                            <button data-testid="button-modal-close" className="modal_close_btn absolute right-4 top-4 cursor-pointer sm:right-5 sm:top-5">
                                <img src={CloseIcon} alt="Close icon" onClick={onClose} />
                            </button>
                        )}
                        {children}
                    </div>
                </div>
            </Fade>
        </MuiModal>
    );
};

export default Modal;
